/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EligibleResult } from './eligibleResult';


export interface CapabilityEligibleResultApiModel { 
    employeeId: number;
    capabilityId: number;
    validUntil?: string | null;
    eligibleResult: EligibleResult;
}
export namespace CapabilityEligibleResultApiModel {
}


